import * as Yup from 'yup';

export const newTableSchema = Yup.object().shape({
  status: Yup.string().optional(),
  orders: Yup.string().optional(),
  customers: Yup.number().required('Customers is required'),
  name: Yup.string().optional(),
  figure: Yup.string().required('Figure is required'),
  coordinates: Yup.array().optional(),
});
